import { SvgIcon, SvgIconProps } from '@mui/material';

export function AngleDownIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16.9999 9.17116C16.8126 8.98491 16.5591 8.88037 16.2949 8.88037C16.0308 8.88037 15.7773 8.98491 15.5899 9.17116L11.9999 12.7112L8.45995 9.17116C8.27259 8.98491 8.01913 8.88037 7.75495 8.88037C7.49076 8.88037 7.23731 8.98491 7.04995 9.17116C6.95622 9.26413 6.88183 9.37473 6.83106 9.49659C6.78029 9.61845 6.75415 9.74915 6.75415 9.88116C6.75415 10.0132 6.78029 10.1439 6.83106 10.2657C6.88183 10.3876 6.95622 10.4982 7.04995 10.5912L11.2899 14.8312C11.3829 14.9249 11.4935 14.9993 11.6154 15.0501C11.7372 15.1008 11.8679 15.127 11.9999 15.127C12.132 15.127 12.2627 15.1008 12.3845 15.0501C12.5064 14.9993 12.617 14.9249 12.7099 14.8312L16.9999 10.5912C17.0937 10.4982 17.1681 10.3876 17.2188 10.2657C17.2696 10.1439 17.2957 10.0132 17.2957 9.88116C17.2957 9.74915 17.2696 9.61845 17.2188 9.49659C17.1681 9.37473 17.0937 9.26413 16.9999 9.17116Z"
          fill="currentcolor"
        />
      </svg>
    </SvgIcon>
  );
}
